const state = {
    pools:[],
}

export default state
